import React from 'react';

const DiscoverSection = () => {
  const cards = [
    {
      title: 'Our History',
      description: 'RogerOps was founded with a, single goal in mind: simplify and optimize cloud adoption for businesses of all sizes. Born out of deep industry experience in cloud engineering and DevOps, we’ve grown into a trusted partner for clients across the globe — helping them scale faster, save smarter, and build more secure cloud-native systems on AWS, Azure, and GCP.'
    },
    {
      title: 'Our Mission',
      description: 'Our mission is to empower organizations with cloud clarity. We aim to eliminate cloud complexity through automation, architecture, and expert guidance — so you can focus on innovation, not infrastructure. Whether it’s cloud migration, cost optimization, or Kubernetes orchestration, we bring the strategy and execution to turn challenges into outcomes.'
    },
    {
      title: 'Meet Our Team',
      description: 'We\'re a team of experienced cloud architects, DevOps engineers, MLOps specialists, FinOps specialists and security pros — united by a passion for solving tough cloud problems. Our diverse backgrounds bring a unique blend of technical mastery and business understanding, ensuring we deliver not just solutions, but value. With RogerOps, you\'re not just hiring a team — you\'re gaining a strategic partner in your cloud journey.'
    }
  ];

  
  return (
    <section className="py-20 bg-[#f3f4f6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Discover RogerOps
        </h2>
        <p className="text-lg text-gray-600 mb-12 max-w-3xl">
          At RogerOps, we don't just manage cloud infrastructure - we engineer 
          excellence in the cloud. Whether you're scaling a startup or 
          optmizing enterprise systems, RogerOps is your trusted partner.
          RogerOps is committed to deliver cutting-edge cloud
          solutions that drive innovation and business growth. 
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 hover:shadow-lg transition-shadow"
            >
              <h3 className="text-xl font-semibold text-[#3498db] mb-4">
                {card.title}
              </h3>
              <p className="text-gray-600">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DiscoverSection; 